import { lazy, Suspense } from 'react';
import { isProdEnv } from '@Services/env/environment.service.ts';
import { DevTool } from '@hookform/devtools';
import React from 'react';

const TanStackRouterDevtools =
  isProdEnv()
    ? () => null // Render nothing in production
    : lazy(() =>
        // Lazy load in development
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        }))
      );

export const RouterDevTools = () => (
  <Suspense>
    <TanStackRouterDevtools />
  </Suspense>
);


interface LiliDevToolProps {
  control: any;
}

export const LiliDevTool: React.FC<LiliDevToolProps> = ({ control }) =>
  isProdEnv() ? null : <DevTool control={control} />;
